import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { FeedbackSuggestedPlanModel } from '../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { APMultiTermsQuery } from '../../queries/ap_mm_terms_query';
import { APPastTermsQuery } from '../../queries/ap_past_terms_query';
import { APTermCourseDataQueryhelper } from '../../queries/ap_term_course_data_query_helper';
import { APTermsQuery } from '../../queries/ap_terms_query';

export class PlannerMmTermsController {
  private isEditable: boolean | string;
  private showPastTerms: boolean = false;
  private plannedTerms: APTerm[] = [];
  private showLockUnlockCoursesModal: boolean = false;
  private isLocking: boolean = false;
  private showAdvancedOptions = false;
  private isPlanLoading = false;
  private showPlanLoadingIndicatorBound: () => void;
  private hidePlanLoadingIndicatorBound: () => void;

  constructor(
    private $state: ng.ui.IStateService,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPTermsQuery: APTermsQuery,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAPPastTermsQuery: APPastTermsQuery,
    private ngAPMultiTermsQuery: APMultiTermsQuery,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
  ) {
    this.showPlanLoadingIndicatorBound = this.showPlanLoadingIndicator.bind(this);
    this.hidePlanLoadingIndicatorBound = this.hidePlanLoadingIndicator.bind(this);
  }

  $onInit() {
    this.showPastTerms = false;
    this.ngComponentCommunicatorService.subscribe('PLAN_LOADING', this.showPlanLoadingIndicatorBound);
    this.ngComponentCommunicatorService.subscribe('PLAN_LOADING_SUCCESS', this.hidePlanLoadingIndicatorBound);
  }

  showPlanLoadingIndicator() {
    this.isPlanLoading = true;
  }
  hidePlanLoadingIndicator() {
    this.isPlanLoading = false;
  }
  toggleCompletedTerms() {
    this.showPastTerms = !this.showPastTerms;
  }

  $onChanges() {
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }
}

class APPlannerMmTerms implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: any;

  constructor() {
    this.controller = PlannerMmTermsController;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/planner_terms/planner_mm_terms.html';
    this.bindings = {
      isEditable: '<?'
    };
  }
}

angular.module('capability-ng-academic-planner').component('apPlannerMmTerms', new APPlannerMmTerms());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_terms/planner_mm_terms.ts